import { render, staticRenderFns } from "./EmptyImage.vue?vue&type=template&id=6b2a5b8e&scoped=true&"
import script from "./EmptyImage.vue?vue&type=script&lang=js&"
export * from "./EmptyImage.vue?vue&type=script&lang=js&"
import style0 from "./EmptyImage.vue?vue&type=style&index=0&id=6b2a5b8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2a5b8e",
  null
  
)

export default component.exports